import { IeLynxObject } from "../../common/models/eLynxObject";
import restService from "../rest-service/RestService";
import { IOrganization } from "./Models";


const OrganizationDataService = {


    getOrganizations: async (signal?: AbortSignal): Promise<IOrganization[]> => {

        const response = await restService.get<IOrganization[]>("organizations", signal);
        return response.data;

    },

    getOrganizationDevices: async (
        contextGroupID: number,
        includeChildOrganizations: boolean,
        excludeSatelliteDevices: boolean,
        signal?: AbortSignal
    ): Promise<Array<IeLynxObject>> => {
        const path: string = "organizations/devices";

        var queryParams = {
            contextGroupID: contextGroupID,
            includeChildOrganizations: includeChildOrganizations,
            excludeSatelliteDevices: excludeSatelliteDevices
        };

        const response = await restService.get<Array<IeLynxObject>, GetOrganizationDevicesQueryParamsType>(path, signal, queryParams);
        return response.data;
    }
};

type GetOrganizationDevicesQueryParamsType = {
    contextGroupID: number;
    includeChildOrganizations: boolean;
    excludeSatelliteDevices: boolean;
};

export default OrganizationDataService;

